<template>
  <main ref="loadDetail">
    <header class="mb-6">
      <div v-if="campaign.file">
        <img class="w-full rounded-sm" :src="imageCampaign" alt="Image" />
      </div>
      <vx-card class="rounded-none">
        <div class="vx-row items-center">
          <div class="vx-col mb-8 md:mb-0 w-full md:w-3/4 lg:w-4/5 xl:w-5/6">
            <h4 class="mb-4">{{ campaign.name }}</h4>
            <p class="mb-4">
              <strong>{{ campaign.mulai }} - {{ campaign.selesai }}</strong>
            </p>
            <h5 class="mb-4">
              Rp {{ formatRupiah(campaign.donasi_terkumpul) }} dari
              <strong class="text-warning">Rp {{ formatRupiah(campaign.donasi) }}</strong>
            </h5>
          </div>
          <div class="vx-col w-full md:w-1/4 lg:w-1/5 xl:w-1/6">
            <div class="flex flex-col justify-center">
              <h1 class="text-success text-center mb-4">
                <strong>{{ donationPercent(campaign) }}%</strong>
              </h1>
              <p class="text-center">Donasi Terkumpul</p>
            </div>
          </div>
        </div>
      </vx-card>
    </header>

    <section class="mb-6 flex justify-end">
      <vs-button
        :to="`/dashboard/campaign/${campaign.id}/edit`"
        class="rounded-none"
        size="small"
        color="primary"
        type="border"
        >Edit</vs-button
      >
    </section>

    <!-- Orang yang donasi -->
    <section>
      <info-table-campaign :campaignDetail="campaign" />
    </section>
  </main>
</template>
<script>
import emptyImage from "@/assets/images/elements/empty.png";
import InfoTableCampaign from "./component/InfoTableCampaign.vue";
import url from "@/url";

export default {
  components: {
    InfoTableCampaign,
  },
  computed: {
    imageCampaign() {
      return this.campaign.file !== null
        ? this.campaign.file.includes("http")
          ? this.campaign.file
          : `${this.url.baseFl}/${this.campaign.file}`
        : this.emptyImage;
    },
  },
  methods: {
    getDataDetail(id) {
      this.$vs.loading({
        container: this.$refs.loadDetail,
        color: "primary",
      });
      this.$store
        .dispatch("campaign/getDetailCampaign", id)
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadDetail);
          this.campaign = v;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadDetail);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    donationPercent(campaign) {
      if (!campaign.donasi_terkumpul) {
        campaign.donasi_terkumpul = 0;
      }

      return Math.ceil(
        (parseInt(campaign.donasi_terkumpul) / parseInt(campaign.donasi)) * 100
      );
    },
  },
  data: () => ({
    url,
    emptyImage,
    campaign: null,
    donors: [],
  }),
  mounted() {
    if (this.$store.state.campaign.campaign.length !== 0) {
      this.campaign = this.$store.getters["campaign/detail"](this.$route.params.id);
    } else {
      this.getDataDetail(this.$route.params.id);
    }
  },
  created() {
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss" scoped>
img {
  max-height: 300px;
  overflow: auto;
  object-fit: cover;
}
</style>
